import { render, staticRenderFns } from "./expandCollapseButton.vue?vue&type=template&id=1bbc315d&scoped=true&"
import script from "./expandCollapseButton.vue?vue&type=script&lang=js&"
export * from "./expandCollapseButton.vue?vue&type=script&lang=js&"
import style0 from "./expandCollapseButton.vue?vue&type=style&index=0&id=1bbc315d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbc315d",
  null
  
)

export default component.exports